export default "__VITE_ASSET__CFBpFAmp__"